import FormTrab from './FormTrab/FormTrab'
import FormPatr from './FormPatr/FormPatr';
export const FormTrabPage = FormTrab
export const FormPatrPage = FormPatr
